import React from 'react';
import { useIntl } from 'react-intl';

import { HorizontalCenterBlock } from '../../../styled';
import { FieldSwitch, FormLabel } from '../../ui';
import { ContentWrapper, ValidationSwitchWrapper } from './style';

const MagicLink = (): JSX.Element => {
  const intl = useIntl();

  return (
    <HorizontalCenterBlock>
      <ContentWrapper>
        <FormLabel
          label={intl.formatMessage({ id: 'settings.email-settings.magic-link.title' })}
          description={intl.formatMessage({ id: 'settings.email-settings.magic-link.subtitle' })}
        />

        <ValidationSwitchWrapper>
          <FieldSwitch
            name="enable_magic_link"
            data-test-id="enable_magic_link"
            caption={intl.formatMessage({
              id: 'settings.email-settings.magic-link.switch.caption'
            })}
            label={intl.formatMessage({ id: 'settings.email-settings.magic-link.switch.title' })}
          />
        </ValidationSwitchWrapper>
      </ContentWrapper>
    </HorizontalCenterBlock>
  );
};

export default MagicLink;
